<div class="popup">
  <div class="alert alert-success" *ngIf="(success  | async) === true" i18n="@@PasswordRecoverySuccess">На ваш e-mail выслана инструкция по восстановлению пароля</div>
  <div class="alert alert-danger" *ngIf="(serverError | async) === true" i18n="@@PasswordRecoveryError">Возникла ошибка</div>
  <div class="alert alert-warning" *ngIf="(userNotFoundError | async) === true" i18n="@@EmailNotFound">Пользователь с таким e-mail не найден</div>

  <form [formGroup]="forgotForm" novalidate (ngSubmit)="onSubmit()" *ngIf="(success | async) === false">
    <div class="form-control-group">
      <label i18n="@@ForgotPasswordHint">Укажите e-mail, который вы использователи при регистрации</label>

      <div class="form-control-group">
        <input formControlName="email" fullWidth nbInput id="resetInputEmail1" type="email" i18n-placeholder="@@EnterEmail" placeholder="Введите e-mail" autocomplete="off">
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.email.errors?.required && forgotForm.controls.email.touched" i18n>укажите e-mail
      </div>
      <div class="invalid-feedback"
           *ngIf="forgotForm.controls.email.errors?.email && forgotForm.controls.email.touched" i18n>неверный e-mail
      </div>
    </div>

    <div class="form-control-group form-content__btn">

      <button [disabled]="forgotForm.invalid" nbButton type="submit" i18n>Отправить</button>
    </div>
  </form>
</div>
